import React from 'react';
import {
  Content,
  ContentHeader,
  Link,
  SupportButton,
} from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityListProvider,
  EntityOwnerPicker,
  EntityTagPicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import {
  TechDocsIndexPageProps,
  TechDocsPageWrapper,
  TechDocsPicker,
  EntityListDocsTable,
} from '@backstage/plugin-techdocs';
import TechdocsOnboardingBanner from '../home/bannerComponent/techdocsOnboardingBanner';
import { TechdocsOwnedHeader } from './techdocsOwnedHeader';

export const CustomTechDocsHome = (props: TechDocsIndexPageProps) => {
  const { initialFilter = 'owned', columns, actions } = props;
  return (
    <TechDocsPageWrapper>
      <Content>
        <ContentHeader title="">
          <SupportButton>
            <Link to="https://devportal.us.acuitynext.io/docs/default/component/zephyr-techdocs/product-documentation/user/end-user/techdocs/">
              Learn how to register your markdown documentation here
            </Link>
          </SupportButton>
        </ContentHeader>
        <TechdocsOnboardingBanner />
        <TechdocsOwnedHeader />
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <TechDocsPicker />
              <UserListPicker initialFilter={initialFilter} />
              <EntityOwnerPicker />
              <EntityTagPicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <EntityListDocsTable actions={actions} columns={columns} />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </TechDocsPageWrapper>
  );
};
